import { render, staticRenderFns } from "./fromAndSubmit.vue?vue&type=template&id=e0c7ed3a&scoped=true&"
import script from "./fromAndSubmit.vue?vue&type=script&lang=js&"
export * from "./fromAndSubmit.vue?vue&type=script&lang=js&"
import style0 from "./fromAndSubmit.vue?vue&type=style&index=0&id=e0c7ed3a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c7ed3a",
  null
  
)

export default component.exports